

const Facultydata = [
    {
        id : 1,
        image : "./images/profimages/ghosh.jpg",
        name : "Abhijit Ghosh  ",
        link : "AbhijitGhosh",
    },
    {
        id : 2,
        image : "./images/profimages/prof20.jpeg",
        name : " Ajay Kumar Kushwaha",
        link : "AjayKumarKushwaha",
    },
    {
        id : 3,
        image : "./images/profimages/prof1.jpg",
        name : " Chandan Halder",
        link : "ChandanHalder",
    },
    {
        id : 4,
        image : "./images/profimages/prof3.jpg",
        name : " Dhirendra Kumar Rai",
        link : "DhirendraKumarRai",
    },
    {
        id : 5,
        image : "./images/profimages/basha.jpg",
        name : " Dudekula Althaf Basha",
        link : "DudekulaAlthafBasha",
    },
    {
        id : 6,
        image : "./images/profimages/prof6.jpg",
        name : " Eswara Prasad Korimilli",
        link : "EswarPrasadKormilli",
    },
    {
        id : 7,
        image : "./images/profimages/hemanth.jpg",
        name : " Hemant Borkar",
        link : "HemantBorkar",
    },
    {
        id : 8,
        image : "./images/profimages/muru.jpg",
        name : " Jayaprakash Murugesan",
        link : "JayaprakashMurugesan",
    },
    {
        id : 9,
        image : "./images/profimages/kbu.jpg",
        name : " Khushubo Devi",
        link : "KhushuboDevi",
    },
    {
        id : 10,
        image : "./images/profimages/prof11.jpg",
        name : " Mrigendra Dubey",
        link : "MrigendraDubey",
    },
    {
        id : 11,
        image : "./images/profimages/nissi.jpg",
        name : " Nisheeth Kumar Prasad",
        link : "NisheethKumarPrasad",
    },
    {
        id : 12,
        image : "./images/profimages/shirage.jpg",
        name : " Parasharam M. Shirage",
        link : "ParasharamShirage",
    },
    {
        id : 13,
        image : "./images/profimages/rsm.jpg",
        name : " Ram Sajeevan Maurya",
        link : "RamSajeevanMaurya",
    },
    {
        id : 14,
        image : "./images/profimages/ranjit_sir.jpg"   ,
        name : " Ranjith Kumar Poobalan",
        link : "RanjithKumarPoobalan",
    },  
    {
        id : 15,
        image : "./images/profimages/prof2.jpg",
        name : " Rupesh Devan",
        link : "RupeshDevan",
    },
    {
        id : 16,
        image : "./images/profimages/prof4.png",
        name : " Santosh Hosmani",
        link : "SantoshHosmani",
    },
    {
        id : 17,
        image : "./images/profimages/samal.jpg",
        name : " Sumanta Samal",
        link : "SumantaSamal",
    },
    {
        id : 18,
        image : "./images/profimages/prof13.jpg",
        name : "  Sunil Kumar",
        link : "SunilKumar",
    },
    {
        id : 19,
        image : "./images/profimages/prof18.jpg",
        name : " Venkata Vamsi Koruprolu",
        link : "KVVamsi",
    },
    {
        id : 20,
        image : "./images/profimages/vinod.jpg",
        name : " Vinod Kumar",
        link : "VinodKumar",
    },
    {
        id : 21,
        image : "./images/profimages/vivek.jpeg",
        name : " Vivek Verma",
        link : "VivekVerma",
    },
    
]
export default Facultydata